import {
  Grid,
  IconButton,
  TextField,
  LinearProgress,
  Card,
  CardContent,
  Stack,
  Tooltip,
  Typography,
  Link,
  useMediaQuery,
  TablePagination,
  Autocomplete,
} from "@mui/material";
import Box from "@mui/material/Box";
import {
  DataGrid,
  GridActionsCellItem,
  GridPagination,
} from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  MdOutlineClear,
  MdOutlineDeliveryDining,
  MdOutlinePointOfSale,
  MdPrint,
} from "react-icons/md";
import {
  JOrder,
  setLoading,
  setSearchBody,
  setAssignDriverDialog,
  setChangePosDialog,
} from "../../../../../app/slices/jomla/orderSlice";
import dayjs from "dayjs";
import DateRangepicker from "../../../../../helpers/dateRangePicker";
import { ChangeStatusByChip } from "./ChangeStatusByChip";
import { SelectJItem } from "../../../../../components/Selectors/jomla/SelectJItem";

import { BiDetail } from "react-icons/bi";
import { SelectJSubCategory } from "../../../../../components/Selectors/jomla/SelectJSubCategory";
import { SelectJOrderStatus } from "../../../../../components/Selectors/jomla/SelectJOrderStatus";
import { PointOfSales } from "../../../../../app/slices/posSlice";
import PosForm from "../../../../POS/form";
import { SelectPos } from "../../../../../components/Selectors/SelectPos";
import { SelectDriver } from "../../../../../components/Selectors/jomla/SelectDriver";
import { useTheme } from "@emotion/react";
import { SelectJRep } from "../../../../../components/Selectors/SelectJRep";
import { SelectProvince } from "../../../../../components/Selectors/SelectProvince";
import { BsFillFileEarmarkExcelFill } from "react-icons/bs";
import { toNumber } from "../../../../../components/toNumber";
import { JItems } from "../../../../../app/slices/jomla/itemsSlice";
import { SelectTeamLeader } from "../../../../../components/Selectors/SelectTeamLeader";

const JOrderTable = () => {
  const dispatch = useDispatch();

  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down("md"));

  const _provinces = useSelector((state) => state.provinces.provinces.data);
  const _JOrder = useSelector((state) => state.jOrder.jOrders);
  const _SearchBody = useSelector((state) => state.jOrder.searchBody);
  const _JItems = useSelector((state) => state.JItems.JItemsList.data);
  const _JSubCategory = useSelector(
    (state) => state.JSubCategories.JSubCategoriesList.data
  );
  const _JOrderStatus = useSelector(
    (state) => state.jOrder.jOrderStatuses.data
  );
  const _PointsOfSales = useSelector((state) => state.pointOfsales);
  const _PointOfSales = useSelector(
    (state) => state.pointOfsales.posesList.data
  );
  const user = useSelector((state) => state.user.jRepList.data);
  const drivers = useSelector((state) => state.user.driversList.data);
  const _Role = useSelector((state) => state.user.userInfo.user_roles[0]);
  const _UserInfo = useSelector((state) => state.user.userInfo);
  const _TeamLeader = useSelector((state) => state.team.leaders);

  const PRIVILEGED_USER_ID = "ca40271f-cd02-4f18-b48a-83ae2e2b6fef";

  const has_debt = [
    {
      key: "ديون فقط",
      value: true,
    },
    {
      key: "بدون ديون فقط",
      value: false,
    },
  ];

  const [search, setSearch] = useState(_SearchBody);
  const [pageSize, setPageSize] = useState(15);
  const [currentPage, setCurrentPage] = useState(0);

  function CustomFooter() {
    return (
      <Stack
        direction="row"
        sx={{ justifyContent: "space-between", alignItems: "center" }}
      >
        <Box>
          <Typography color="primary" sx={{ marginX: 2, marginY: 0.5 }}>
            مجموع الفواتير : {parseInt(_JOrder.total_amount).toLocaleString()}{" "}
            (IQD)
          </Typography>
          <Typography color="primary" sx={{ marginX: 2 }}>
            مجموع الديون : {parseInt(_JOrder.total_debt).toLocaleString()} (IQD)
          </Typography>
        </Box>
        <GridPagination />
      </Stack>
    );
  }

  const changeOrderStatus = (id, status) => {
    let params = {
      j_order_status_id: status?.id,
    };
    dispatch(JOrder.updateStatus(id, params, _SearchBody, "getAll"));
  };

  const columns = [
    {
      field: "number",
      headerName: "رقم الطلب",
      flex: 0.5,
    },
    {
      field: "user_name",
      headerName: "النقطة",
      flex: 1,
      renderCell: (params) => {
        return (
          <Stack spacing={1}>
            <Typography>
              <Link
                component="button"
                variant="body2"
                onClick={() => {
                  dispatch(setLoading("jOrders"));
                  dispatch(PointOfSales.getByUserId(params.row.user_id)).then(
                    () => dispatch(setLoading("jOrders"))
                  );
                }}
              >
                {params.row?.user_name}
              </Link>
            </Typography>
            <Typography>
              الديون: {params.row?.user_j_balance?.toLocaleString() || "0"}
            </Typography>
          </Stack>
        );
      },
    },
    {
      field: "items_count",
      headerName: "عدد المنتجات",
      flex: 0.6,
    },
    {
      field: "net_amount",
      headerName: "المبلغ النهائي (IQD)",
      flex: 1,
      renderCell: (params) => params.row.net_amount?.toLocaleString(),
    },
    {
      field: "discount",
      headerName: "الخصم (IQD)",
      flex: 1,
      renderCell: (params) => (
        <Typography variant="body1">
          {params.row.discount?.toLocaleString()}
        </Typography>
      ),
    },
    {
      field: "admin_discount",
      headerName: "خصم الشركة (IQD)",
      flex: 1,
      renderCell: (params) => (
        <Typography variant="body1">
          {params.row.admin_discount?.toLocaleString()}
        </Typography>
      ),
    },
    {
      field: "total_paid",
      headerName: "المدفوع (IQD)",
      flex: 1,
      renderCell: (params) => params.row.total_paid?.toLocaleString(),
    },
    {
      field: "remaining",
      headerName: "المتبقي (IQD)",
      flex: 1,
      renderCell: (params) => params.row.remaining?.toLocaleString(),
    },
    ...(_Role === "super_admin" || _UserInfo?.id === PRIVILEGED_USER_ID
      ? [
          {
            field: "net_revenue",
            headerName: "الربح (IQD)",
            flex: 1,
            renderCell: (params) =>
              toNumber(params.row.net_revenue)?.toLocaleString(),
          },
        ]
      : []),
    {
      field: "created_at",
      headerName: "تاريخ الانشاء",
      flex: 1,
      renderCell: (params) => (
        <Stack spacing={0}>
          <Typography variant="body1">
            {dayjs(params.row.created_at).format("YYYY-MM-DD")}
          </Typography>
          <Typography variant="body1">
            {dayjs(params.row.created_at).format("hh:mm a")}
          </Typography>
        </Stack>
      ),
    },
    {
      field: "j_order_status_id",
      headerName: "الحالة",
      flex: 1.2,
      renderCell: (params) => {
        return (
          <ChangeStatusByChip
            id={params.row.j_order_status_id}
            status={params.row.j_order_status_name}
            onChangeStatus={(item) => {
              changeOrderStatus(params.row.id, item);
            }}
          />
        );
      },
    },
    {
      field: "actions",
      headerName: "العمليات",
      type: "actions",
      flex: 0.5,
      getActions: (params) => {
        const actions = [];
        // Permissions logic
        // j_order_view
        if (
          [
            "super_admin",
            "admin",
            "team_leader",
            "representative",
            "wholesale",
          ].includes(_Role)
        ) {
          actions.push(
            <GridActionsCellItem
              key="view"
              icon={<BiDetail />}
              label="تفاصيل الطلب"
              onClick={() => {
                window.open(`/app/wholesale/order/${params.row.id}`, "_blank");
              }}
              showInMenu
              title="تفاصيل الطلب"
            />
          );
        }
        // Print (no permission check)
        actions.push(
          <GridActionsCellItem
            key="print"
            icon={<MdPrint />}
            label="طباعة فاتورة بيع"
            onClick={() => {
              dispatch(JOrder.getByIdForPrint(params.row.id));
            }}
            showInMenu
            title="طباعة فاتورة بيع"
          />
        );
        // كشف الحساب
        actions.push(
          <GridActionsCellItem
            key="account_statement"
            icon={<BsFillFileEarmarkExcelFill />}
            label="كشف الحساب"
            onClick={() => {
              localStorage.setItem("isWholeSale", "1");
              window.open(
                `/app/wallets/transactions/${params.row.user_id}`,
                "_blank"
              );
            }}
            showInMenu
            title="كشف الحساب"
          />
        );
        // assign_j_order_driver_edit
        if (
          [
            "super_admin",
            "admin",
            "team_leader",
            "representative",
            "wholesale",
          ].includes(_Role)
        ) {
          actions.push(
            <GridActionsCellItem
              key="assign_driver"
              icon={
                <MdOutlineDeliveryDining
                  color={params.row.driver_name ? "#d32f2f" : undefined}
                />
              }
              label={
                params.row.driver_name
                  ? `السائق: ${params.row.driver_name}`
                  : "تعيين سائق"
              }
              onClick={() => {
                dispatch(
                  setAssignDriverDialog({
                    order_id: params.row.id,
                    driver_id: params.row.driver_id ?? null,
                  })
                );
              }}
              showInMenu
              title={
                params.row.driver_name
                  ? `السائق: ${params.row.driver_name}`
                  : "تعيين سائق"
              }
            />
          );
        }
        // change_pos_j_order_edit
        if (
          [1, 2, 3, 4].includes(params.row.j_order_status_id) &&
          [
            "super_admin",
            "admin",
            "team_leader",
            "representative",
            "wholesale",
          ].includes(_Role)
        ) {
          actions.push(
            <GridActionsCellItem
              key="change_pos"
              icon={<MdOutlinePointOfSale color="green" />}
              label="تغيير نقطة البيع"
              onClick={() => {
                dispatch(
                  setChangePosDialog({
                    order_id: params.row.id,
                    user_id: params.row.user_id,
                    note: "",
                  })
                );
              }}
              showInMenu
              title="تغيير نقطة البيع"
            />
          );
        }
        return actions;
      },
    },
  ];

  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(JOrder.getAll(_SearchBody));
    }, 500);
    return () => clearTimeout(timeout);
  }, [_SearchBody, dispatch]);

  useEffect(() => {
    dispatch(
      setSearchBody({
        number: search.number,
        j_sub_category_id: search.j_sub_category_id ?? "",
        pos_id: search.pos_id ?? "",
        j_rep_id: search.j_rep_id ?? "",
        j_order_status_ids: search.j_order_status_ids
          ? JSON.stringify(search.j_order_status_ids)
          : "",
        j_item_id: search.j_item_id ?? "",
        start_date: search.start_date ?? "",
        end_date: search.end_date ?? "",
        driver_id: search.driver_id ?? "",
        province_id: search.province_id ?? "",
        has_debt: search.has_debt ?? "",
        pos_number: search.pos_number ?? "",
        team_leader_id: search.team_leader_id ?? "",
        skip: currentPage * pageSize,
        take: pageSize,
      })
    );
  }, [currentPage, dispatch, pageSize, search]);

  useEffect(() => {
    dispatch(JItems.getAllList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Card>
      {_PointsOfSales.pos.dialog ? (
        <PosForm from={"JOrders"} jOrderSearchBody={_SearchBody} />
      ) : null}
      <CardContent>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item xs={12} md={3}>
            <TextField
              type="number"
              size="small"
              value={search.number}
              onChange={(e) => {
                setSearch({
                  ...search,
                  number: e.target.value,
                });
              }}
              label="رقم الطلب"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <SelectJOrderStatus
              multiple
              onChange={(event, value) => {
                var ids = value.map((x) => x.id);
                setSearch({
                  ...search,
                  j_order_status_ids: value ? ids : null,
                });
              }}
              value={
                _JOrderStatus?.filter((x) =>
                  search.j_order_status_ids?.includes(x.id)
                ) ?? []
              }
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <SelectJSubCategory
              onChange={(e, newValue) => {
                setSearch({
                  ...search,
                  j_sub_category_id: newValue ? newValue.id : null,
                });
              }}
              value={
                _JSubCategory.filter(
                  (x) => x.id === search.j_sub_category_id
                )[0] ?? null
              }
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <SelectJItem
              onChange={(e, newValue) => {
                setSearch({
                  ...search,
                  j_item_id: newValue ? newValue.id : null,
                });
              }}
              value={
                _JItems.filter((x) => x.id === search.j_item_id)[0] ?? null
              }
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              type="number"
              size="small"
              value={search.pos_number}
              onChange={(e) => {
                setSearch({
                  ...search,
                  pos_number: e.target.value,
                });
              }}
              label="رقم النقطة"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <SelectPos
              onChange={(e, newValue) => {
                setSearch({
                  ...search,
                  pos_id: newValue ? newValue.id : null,
                });
              }}
              value={
                _PointOfSales?.filter((x) => x.id === search.pos_id)[0] ?? null
              }
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <SelectJRep
              onChange={(e, newValue) => {
                setSearch({
                  ...search,
                  j_rep_id: newValue ? newValue.id : null,
                });
              }}
              value={
                user.filter((user) => user.id === search.j_rep_id)[0] ?? null
              }
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <SelectProvince
              onChange={(e, newValue) => {
                setSearch({
                  ...search,
                  province_id: newValue ? newValue.id : null,
                });
              }}
              value={
                _provinces?.filter((x) => x.id === search.province_id)[0] ??
                null
              }
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <SelectDriver
              onChange={(e, newValue) => {
                setSearch({
                  ...search,
                  driver_id: newValue ? newValue.id : null,
                });
              }}
              value={
                drivers.filter((user) => user.id === search.driver_id)[0] ??
                null
              }
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <Autocomplete
              options={has_debt}
              getOptionLabel={(option) => {
                return option.key;
              }}
              onChange={(e, newValue) => {
                setSearch({
                  ...search,
                  has_debt: newValue ? newValue.value : null,
                });
              }}
              value={
                has_debt.filter((x) => x.value === search.has_debt)[0] ?? null
              }
              renderInput={(params) => (
                <TextField {...params} label="الديون" size="small" />
              )}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <SelectTeamLeader
              supervisor_id={"true"}
              onChange={(event, value) => {
                setSearch({
                  ...search,
                  team_leader_id: value ? value.id : null,
                });
              }}
              value={
                _TeamLeader.data?.filter(
                  (x) => x.id === search.team_leader_id
                )[0] ?? null
              }
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <DateRangepicker
              startDate={search.start_date}
              endDate={search.end_date}
              handleOnChange={(searchDate) => {
                const updatedFilter = {
                  from: dayjs(searchDate[0].startDate).format("YYYY-MM-DD"),
                  to: dayjs(searchDate[0].endDate).format("YYYY-MM-DD"),
                };
                if (
                  updatedFilter.from !== searchDate.startDate ||
                  updatedFilter.to !== searchDate.endDate
                ) {
                  setSearch({
                    ...search,
                    start_date: dayjs(searchDate[0].startDate).format(
                      "YYYY-MM-DD"
                    ),
                    end_date: dayjs(searchDate[0].endDate).format("YYYY-MM-DD"),
                  });
                }
              }}
            />
          </Grid>
          <Grid item xs={12} md={0.5}>
            <Stack direction="row" spacing={0} sx={{ alignItems: "center" }}>
              <Tooltip title="تصدير ملف اكسل">
                <IconButton
                  onClick={() => {
                    dispatch(JOrder.exportExcel(_SearchBody));
                  }}
                >
                  <BsFillFileEarmarkExcelFill />
                </IconButton>
              </Tooltip>
              <Tooltip title="الغاء الفلتر">
                <IconButton
                  onClick={() => {
                    setSearch({
                      number: "",
                      j_sub_category_id: null,
                      j_item_id: null,
                      start_date: null,
                      end_date: null,
                      driver_id: null,
                      j_order_status_ids: null,
                      pos_id: null,
                      j_rep_id: null,
                      province_id: null,
                      has_debt: null,
                      pos_number: "",
                    });
                    setPageSize(15);
                    setCurrentPage(0);
                  }}
                >
                  <MdOutlineClear />
                </IconButton>
              </Tooltip>
            </Stack>
          </Grid>
          {smallScreen ? (
            _JOrder?.data?.length > 0 ? (
              <Grid item xs={12}>
                {_JOrder.loading ? <LinearProgress /> : null}
                <Stack spacing={2} sx={{ mt: 1 }}>
                  {_JOrder.data.map((order, index) => (
                    <Card
                      key={index}
                      sx={{
                        borderRadius: 2,
                        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                        transition: "all 0.3s ease",
                        "&:hover": {
                          boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
                          transform: "translateY(-2px)",
                        },
                      }}
                    >
                      <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
                        <Stack spacing={2}>
                          {/* Header Section */}
                          <Stack
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{
                              pb: 1.5,
                              borderBottom: "1px solid",
                              borderColor: "divider",
                            }}
                          >
                            <Typography
                              variant="h5"
                              color="primary"
                              sx={{ fontWeight: 600 }}
                            >
                              #{order.number}
                            </Typography>
                            <ChangeStatusByChip
                              id={order.j_order_status_id}
                              status={order.j_order_status_name}
                              onChangeStatus={(item) => {
                                changeOrderStatus(order.id, item);
                              }}
                            />
                          </Stack>

                          {/* POS Info */}
                          <Box
                            sx={{
                              bgcolor: "action.hover",
                              p: 1.5,
                              borderRadius: 1.5,
                            }}
                          >
                            <Stack
                              direction="row"
                              spacing={1}
                              alignItems="center"
                            >
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                النقطة:
                              </Typography>
                              <Link
                                component="button"
                                variant="body1"
                                sx={{ fontWeight: 500 }}
                                onClick={() => {
                                  dispatch(setLoading("jOrders"));
                                  dispatch(
                                    PointOfSales.getByUserId(order.user_id)
                                  ).then(() => dispatch(setLoading("jOrders")));
                                }}
                              >
                                {order.user_name}
                              </Link>
                            </Stack>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                              sx={{ mt: 0.5, display: "block" }}
                            >
                              الديون:{" "}
                              {order?.user_j_balance?.toLocaleString() || "0"}{" "}
                              IQD
                            </Typography>
                          </Box>

                          {/* Order Details Grid */}
                          <Grid container spacing={1.5}>
                            <Grid item xs={6}>
                              <Box
                                sx={{
                                  p: 1,
                                  bgcolor: "background.default",
                                  borderRadius: 1,
                                }}
                              >
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                  display="block"
                                >
                                  عدد المنتجات
                                </Typography>
                                <Typography
                                  variant="h6"
                                  sx={{ fontWeight: 600 }}
                                >
                                  {order.items_count}
                                </Typography>
                              </Box>
                            </Grid>
                            <Grid item xs={6}>
                              <Box
                                sx={{
                                  p: 1,
                                  bgcolor: "background.default",
                                  borderRadius: 1,
                                }}
                              >
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                  display="block"
                                >
                                  المبلغ النهائي
                                </Typography>
                                <Typography
                                  variant="h6"
                                  sx={{ fontWeight: 600 }}
                                >
                                  {order.net_amount?.toLocaleString()}
                                </Typography>
                              </Box>
                            </Grid>
                            <Grid item xs={6}>
                              <Box
                                sx={{
                                  p: 1,
                                  bgcolor: "background.default",
                                  borderRadius: 1,
                                }}
                              >
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                  display="block"
                                >
                                  الخصم
                                </Typography>
                                <Typography
                                  variant="body1"
                                  sx={{ fontWeight: 500 }}
                                >
                                  {order.discount?.toLocaleString()}
                                </Typography>
                              </Box>
                            </Grid>
                            <Grid item xs={6}>
                              <Box
                                sx={{
                                  p: 1,
                                  bgcolor: "background.default",
                                  borderRadius: 1,
                                }}
                              >
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                  display="block"
                                >
                                  خصم الشركة
                                </Typography>
                                <Typography
                                  variant="body1"
                                  sx={{ fontWeight: 500 }}
                                >
                                  {order.admin_discount?.toLocaleString()}
                                </Typography>
                              </Box>
                            </Grid>
                            <Grid item xs={6}>
                              <Box
                                sx={{
                                  p: 1,
                                  bgcolor: "success.lighter",
                                  borderRadius: 1,
                                }}
                              >
                                <Typography
                                  variant="caption"
                                  color="success.dark"
                                  display="block"
                                >
                                  المدفوع
                                </Typography>
                                <Typography
                                  variant="body1"
                                  sx={{
                                    fontWeight: 600,
                                    color: "success.dark",
                                  }}
                                >
                                  {order.total_paid?.toLocaleString()}
                                </Typography>
                              </Box>
                            </Grid>
                            <Grid item xs={6}>
                              <Box
                                sx={{
                                  p: 1,
                                  bgcolor: "warning.lighter",
                                  borderRadius: 1,
                                }}
                              >
                                <Typography
                                  variant="caption"
                                  color="warning.dark"
                                  display="block"
                                >
                                  المتبقي
                                </Typography>
                                <Typography
                                  variant="body1"
                                  sx={{
                                    fontWeight: 600,
                                    color: "warning.dark",
                                  }}
                                >
                                  {order.remaining?.toLocaleString()}
                                </Typography>
                              </Box>
                            </Grid>
                          </Grid>

                          {/* Date Section */}
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                              pt: 1,
                            }}
                          >
                            <Typography variant="body2" color="text.secondary">
                              {dayjs(order.created_at).format("YYYY-MM-DD")}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              •
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              {dayjs(order.created_at).format("hh:mm a")}
                            </Typography>
                          </Box>

                          {/* Actions */}
                          <Stack
                            direction="row"
                            spacing={1}
                            justifyContent="center"
                            sx={{
                              pt: 1.5,
                              borderTop: "1px solid",
                              borderColor: "divider",
                            }}
                          >
                            <Tooltip title="تفاصيل الطلب" arrow>
                              <IconButton
                                size="large"
                                color="primary"
                                sx={{
                                  bgcolor: "primary.lighter",
                                  "&:hover": { bgcolor: "primary.light" },
                                }}
                                onClick={() => {
                                  window.open(
                                    `/app/wholesale/order/${order.id}`,
                                    "_blank"
                                  );
                                }}
                              >
                                <BiDetail />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="طباعة فاتورة بيع" arrow>
                              <IconButton
                                size="large"
                                color="info"
                                sx={{
                                  bgcolor: "info.lighter",
                                  "&:hover": { bgcolor: "info.light" },
                                }}
                                onClick={() => {
                                  dispatch(JOrder.getByIdForPrint(order.id));
                                }}
                              >
                                <MdPrint />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="كشف الحساب" arrow>
                              <IconButton
                                size="large"
                                color="success"
                                sx={{
                                  bgcolor: "success.lighter",
                                  "&:hover": { bgcolor: "success.light" },
                                }}
                                onClick={() => {
                                  localStorage.setItem("isWholeSale", "1");
                                  window.open(
                                    `/app/wallets/transactions/${order.user_id}`,
                                    "_blank"
                                  );
                                }}
                              >
                                <BsFillFileEarmarkExcelFill />
                              </IconButton>
                            </Tooltip>
                            <Tooltip
                              title={
                                order.driver_name
                                  ? `السائق: ${order.driver_name}`
                                  : "تعيين سائق"
                              }
                              arrow
                            >
                              <IconButton
                                size="large"
                                color={order.driver_name ? "error" : "default"}
                                sx={{
                                  bgcolor: order.driver_name
                                    ? "error.lighter"
                                    : "action.hover",
                                  "&:hover": {
                                    bgcolor: order.driver_name
                                      ? "error.light"
                                      : "action.selected",
                                  },
                                }}
                                onClick={() => {
                                  dispatch(
                                    setAssignDriverDialog({
                                      order_id: order.id,
                                      driver_id: order.driver_id ?? null,
                                    })
                                  );
                                }}
                              >
                                <MdOutlineDeliveryDining />
                              </IconButton>
                            </Tooltip>
                            {[1, 2, 3, 4].includes(order.j_order_status_id) && (
                              <Tooltip title="تغيير نقطة البيع" arrow>
                                <IconButton
                                  size="large"
                                  sx={{
                                    bgcolor: "success.lighter",
                                    color: "success.main",
                                    "&:hover": { bgcolor: "success.light" },
                                  }}
                                  onClick={() => {
                                    dispatch(
                                      setChangePosDialog({
                                        order_id: order.id,
                                        user_id: order.user_id,
                                        note: "",
                                      })
                                    );
                                  }}
                                >
                                  <MdOutlinePointOfSale />
                                </IconButton>
                              </Tooltip>
                            )}
                          </Stack>
                        </Stack>
                      </CardContent>
                    </Card>
                  ))}
                </Stack>
                <Card sx={{ mt: 2, borderRadius: 2 }}>
                  <TablePagination
                    component="div"
                    count={_JOrder.total}
                    rowsPerPage={pageSize}
                    page={currentPage}
                    onPageChange={(e, newPage) => setCurrentPage(newPage)}
                    rowsPerPageOptions={[15, 25, 50, 100]}
                    onRowsPerPageChange={(event) => {
                      const newRowsPerPage = parseInt(event.target.value, 10);
                      setPageSize(newRowsPerPage);
                    }}
                  />
                </Card>
              </Grid>
            ) : (
              <Grid item xs={12}>
                <Card sx={{ borderRadius: 2 }}>
                  <Typography m={2} variant="h5" color="primary" align="center">
                    لا توجد بيانات
                  </Typography>
                </Card>
              </Grid>
            )
          ) : (
            <Grid item xs={12}>
              <Box sx={{ height: "66vh", width: "100%" }}>
                {_JOrder.data ? (
                  <DataGrid
                    rows={_JOrder.data.map((x, i) => {
                      return {
                        ...x,
                        index: i + 1 + pageSize * currentPage,
                      };
                    })}
                    columns={columns}
                    pageSize={pageSize}
                    page={currentPage}
                    rowCount={_JOrder.total}
                    loading={_JOrder.loading}
                    rowHeight={60}
                    pagination
                    paginationMode="server"
                    selectionModel={[]}
                    onPageChange={(newPage) => {
                      setCurrentPage(newPage);
                    }}
                    rowsPerPageOptions={[15, 25, 50, 100]}
                    onPageSizeChange={(newPageSize) => {
                      setPageSize(newPageSize);
                    }}
                    components={{
                      LoadingOverlay: LinearProgress,
                      Footer: CustomFooter,
                    }}
                  />
                ) : (
                  <LinearProgress />
                )}
              </Box>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default JOrderTable;
